// extracted by mini-css-extract-plugin
module.exports = {"about-us":"about-us_about-us__1Bkuh","info":"about-us_info__3EHM_","detail":"about-us_detail__2WqeL"};